import { CheckboxMultiSelect } from "@/common/components/fields/checkbox-multi-select/CheckboxMultiSelect";
import { CourtOption } from "@/pages/system-settings/tabs/counselors/pages/counselor-detail/pages/duty-preferences/CounselorDutyPreferences.types";

interface Props {
  label: string;
  options: CourtOption[];
  value: string[];
  onChange: (ids: string[]) => void;
  placeholder?: string;
  helperText?: string;
  error?: boolean;
}

export function CourtMultiSelect({ label, options, value, onChange, placeholder, helperText, error }: Props) {
  const selected = options.filter((option) => value.includes(option.id));

  return (
    <CheckboxMultiSelect
      label={label}
      options={options}
      value={selected}
      onChange={(newValue) => onChange(newValue.map((option) => option.id))}
      getOptionLabel={(option) => option.label}
      getOptionKey={(option) => option.id}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      placeholder={placeholder}
      error={error}
      // Reserves the helper-text line even with nothing to say, so a validation error appearing or
      // clearing cannot shift the rest of the form up and down.
      helperText={helperText ?? " "}
      fullWidth
    />
  );
}
